module.exports = "/packs/chevron_right-f3642a39506fb84e1c15686999d1e5eb.svg";